// articles on the website will be listed in the order in which they are listed in the researchArticles array

import { ResearchArticles } from '../../types';

// import article objects
import design_principles_for_sensor_arrays from './design_principles_for_sensor_arrays/article';
import optimal_actuator_design from './optimal_actuator_design/article';
import archived_projects from './archived_projects/article';
import models_and_rl from './models_and_rl/article';
import table_tennis from './table_tennis/article';
import reflexive_manipulation from './reflexive_manipulation/article';
import sensor_design_manipulation from './sensor_design_manipulation/article';
import tailoring_solution_accuracy_NMPC from './tailoring_solution_accuracy_NMPC/article';

// Order on website determined by order of list here:
export const researchArticles: ResearchArticles = [
  models_and_rl,
  // table_tennis,
  reflexive_manipulation,
  sensor_design_manipulation,
  tailoring_solution_accuracy_NMPC,
  design_principles_for_sensor_arrays,
  optimal_actuator_design,
  archived_projects,
];
